<template>
  <div data-rocket-location-hash="8a18f7f5895499b1fef7290ea3e469f1" id="main-content">
    <div data-rocket-location-hash="bb4ab2b94b095110bb1a5adb2287a95a" id="sub-header" class="layout-full elementor-page-title">
      <div class="meta-header" >
        <!-- Elementor `page-title` location -->
      </div>
    </div>
    <div id="main" role="main" class="vamtam-main layout-full" >
      <div class="page-wrapper">
        <article id="post-1155" class="full post-1155 page type-page status-publish hentry">
          <div class="page-content clearfix the-content-parent">
            <div data-elementor-type="wp-page" data-elementor-id="1155" class="elementor elementor-1155" data-elementor-post-type="page">
              <section class="elementor-section elementor-top-section elementor-element elementor-element-f7be61b elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="f7be61b" data-element_type="section" data-e-type="section">
                <div data-rocket-location-hash="28e653860718e9e8235291129e117949" class="elementor-container elementor-column-gap-no">
                  <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4b13d00" data-id="4b13d00" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="elementor-element elementor-element-1ad8634 elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-widget-mobile__width-auto elementor-view-default elementor-invisible elementor-widget elementor-widget-icon-box" data-id="1ad8634" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-icon-box-wrapper">
                            <div class="elementor-icon-box-icon">
                              <span  class="elementor-icon">
                              <i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>				</span>
                            </div>
                            <div class="elementor-icon-box-content">
                              <span class="elementor-icon-box-title">
                              <span  >
                              Terms						</span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="elementor-element elementor-element-7d247c5 elementor-widget elementor-widget-heading" data-id="7d247c5" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h1 class="elementor-heading-title elementor-size-default">Terms and Conditions</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-f733752" data-id="f733752" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap">
                    </div>
                  </div>
                </div>
              </section>
              <section class="elementor-section elementor-top-section elementor-element elementor-element-fb5b776 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="fb5b776" data-element_type="section" data-e-type="section">
                <div data-rocket-location-hash="c977a453272ec25e3fb209693a0cfc95" class="elementor-container elementor-column-gap-no">
                  <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2121bc4" data-id="2121bc4" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="elementor-element elementor-element-3281eed elementor-widget elementor-widget-heading" data-id="3281eed" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h3 class="elementor-heading-title elementor-size-default">What information do we collect?</h3>
                        </div>
                      </div>
                      <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-1ade8c6 elementor-widget elementor-widget-text-editor" data-id="1ade8c6" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
                        <div class="elementor-widget-container">
                          When you interact with us, we may collect your name, address, email address(es), telephone number(s), and, where appropriate, date of birth.
                        </div>
                      </div>
                      <div class="elementor-element elementor-element-ef1fada elementor-widget elementor-widget-heading" data-id="ef1fada" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h3 class="elementor-heading-title elementor-size-default">How do we collect information?</h3>
                        </div>
                      </div>
                      <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-3310b1f elementor-widget elementor-widget-text-editor" data-id="3310b1f" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
                        <div class="elementor-widget-container">
                          We may collect information about you whenever you interact with us. For example, when you contact regarding our activities, register as a supporter, send or receive information or sign a petition, you specifically and knowingly provide us with your personal information. We may also receive information about you from third parties – but only if you have given them permission to share your information.								
                        </div>
                      </div>
                      <div class="elementor-element elementor-element-c53b52d elementor-widget elementor-widget-heading" data-id="c53b52d" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h3 class="elementor-heading-title elementor-size-default">Confidentiality</h3>
                        </div>
                      </div>
                      <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-8c76f20 elementor-widget elementor-widget-text-editor" data-id="8c76f20" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
                        <div class="elementor-widget-container">
                          We will not be responsible for the privacy of data collected by websites not owned or managed by Charity, including those linked through our website.								
                        </div>
                      </div>
                      <div class="elementor-element elementor-element-43708a9 elementor-widget elementor-widget-heading" data-id="43708a9" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h3 class="elementor-heading-title elementor-size-default">Making a complaint</h3>
                        </div>
                      </div>
                      <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-ae6b27f elementor-widget elementor-widget-text-editor" data-id="ae6b27f" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
                        <div class="elementor-widget-container">
                          If you are not satisfied with the response, please contact us at <a href="/cdn-cgi/l/email-protection" class="__cf_email__" data-cfemail="99f2f6f7eaedebecf2edf0f6f7d9fcf4f8f0f5b7faf6f4">[email&#160;protected]</a> with the details explaining your concerns. We will review your complaint and investigate if the right procedures have been followed and respond back to you as appropriate. We aim to complete this investigation within 15 working days of receiving your complaint, however, in some cases it may take longer. If you are still unsatisfied with the response, you may contact us.								
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div>
      <!-- End of .page-wrapper -->
    </div>
    <!-- #main -->
  </div>
  <!-- #main-content -->
</template>
<script>
  
  import "@/assets/css/terms.css";

  export default {
    name: 'TermsConditionsView',
  }
</script>
<style scoped>
  .elementor-kit-5 h1 {
    font-size: 40px;
  }
  .elementor-kit-5 h2 {
    font-size: 28px;
  }
  .elementor-kit-5 h4 {
    font-size: 16px;
    font-weight: 400;
  }
  .elementor-5384 .elementor-element.elementor-element-17e5e799 .elementor-heading-title {
    font-size: 12px;
  }
  .elementor-2217 .elementor-element.elementor-global-10925 .elementor-post__title, .elementor-2217 .elementor-element.elementor-global-10925 .elementor-post__title a {
    font-size: 24px;
  }
  .elementor-6907 .elementor-element.elementor-element-63898ee4 .elementor-post__title, .elementor-6907 .elementor-element.elementor-element-63898ee4 .elementor-post__title a {
    font-size: 18px;
  }

  .elementor-5384 .elementor-element.elementor-element-5d498755 {
    font-size: 14px;
  }
</style>